import { render, staticRenderFns } from "./PlaceNotes.vue?vue&type=template&id=10d4e7ea"
import script from "./PlaceNotes.vue?vue&type=script&lang=ts"
export * from "./PlaceNotes.vue?vue&type=script&lang=ts"
import style0 from "./PlaceNotes.vue?vue&type=style&index=0&id=10d4e7ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports